'use client';

import { useTranslations } from 'next-intl';

function DrawIcon({ className }: { className?: string }) {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M52.0819 54.3715L28.3977 54.391L19.3584 54.3973L13.0134 54.3903L7.54765 54.4098C5.59078 54.4167 3.67357 52.8244 3.64087 50.7938L3.54696 45.0011L3.52539 13.2536C3.524 10.9913 5.41409 9.62299 7.45443 9.62229L42.7866 9.61116L56.0687 9.59168C57.3146 9.5896 58.8381 9.98542 59.6144 11.0553C60.1911 11.8498 60.4659 13.2028 60.4659 14.3019L60.4749 50.6769C60.2391 52.6338 58.9139 54.3743 56.8784 54.3736L52.0819 54.3722V54.3715ZM5.80017 11.9214L5.79461 52.2039L58.1668 52.2108L58.1723 11.9284L5.80017 11.9214Z"
        fill="currentColor"
      />
      <path
        d="M28.958 40.2059C28.9636 41.5457 28.3222 42.295 27.0833 42.2991L17.0798 42.3304L12.8572 42.2581C12.0676 42.2449 11.484 41.1896 11.4854 40.4125L11.5146 18.9405C11.516 18.1579 12.3647 17.5158 13.0986 17.5151L27.4944 17.5103C28.0085 17.5103 28.8662 18.3604 28.8683 18.9092L28.958 40.2059ZM13.8742 19.8901L13.8638 39.9889L26.5226 39.9958L26.533 19.897L13.8742 19.8901ZM50.8161 42.313L36.7375 42.3339C35.9584 42.3353 34.9629 41.609 34.9615 40.7597L34.9163 21.1437L34.9107 18.8424C34.9094 18.3708 35.838 17.5075 36.3466 17.5082L51.0735 17.52C51.5633 17.52 52.3417 18.416 52.3417 18.9016L52.348 40.4188C52.348 41.207 51.804 42.3117 50.8161 42.313ZM49.941 19.8741L37.246 19.8859L37.2648 39.9485L49.9598 39.9367L49.941 19.8741ZM50.5567 43.9638C51.3518 43.9597 52.0843 44.64 52.0481 45.2097C52.0196 45.6584 51.2871 46.3534 50.7389 46.3534H37.0304C36.5692 46.3534 35.7518 45.8386 35.6071 45.4324C35.452 44.9983 36.2019 44.0369 36.6812 44.0348L50.5567 43.9638ZM26.9901 46.336L13.0714 46.352C12.5935 46.352 11.79 45.6438 11.781 45.2056C11.772 44.7569 12.5734 44.032 13.0812 44.0299L27.0464 43.977C27.5779 43.975 28.254 44.8111 28.2568 45.2111C28.2596 45.6111 27.5236 46.3353 26.9901 46.336Z"
        fill="currentColor"
      />
      <path
        d="M31.9641 34.3089C32.673 34.3089 33.2476 33.7343 33.2476 33.0254C33.2476 32.3166 32.673 31.7419 31.9641 31.7419C31.2553 31.7419 30.6807 32.3166 30.6807 33.0254C30.6807 33.7343 31.2553 34.3089 31.9641 34.3089Z"
        fill="currentColor"
      />
      <path
        d="M31.9322 27.8713C32.63 27.8713 33.1956 27.3057 33.1956 26.608C33.1956 25.9103 32.63 25.3447 31.9322 25.3447C31.2345 25.3447 30.6689 25.9103 30.6689 26.608C30.6689 27.3057 31.2345 27.8713 31.9322 27.8713Z"
        fill="currentColor"
      />
      <path
        d="M19.5496 35.4629L19.5691 27.152L18.1194 27.4448C17.7959 27.5102 17.222 26.8487 17.2178 26.5363C17.2136 26.224 17.5016 25.6111 17.759 25.3412L19.3736 23.6521C19.8328 23.1721 21.8001 22.7102 21.8091 23.7092L21.9183 35.7238C21.9225 36.1481 21.1274 36.7687 20.7413 36.7909C20.1688 36.825 19.5469 36.1057 19.5483 35.4622L19.5496 35.4629ZM42.9792 35.7349L42.9514 27.8991C42.9451 26.08 41.5587 28.3944 40.7969 27.0198C40.5945 26.6553 40.6655 25.7433 40.9987 25.4261L43.1156 23.4101C43.5163 23.0288 44.9597 23.0601 45.2804 23.5993L45.3493 35.4254C45.3514 35.8295 44.7935 36.5975 44.431 36.7102C44.0081 36.8417 42.9813 36.2372 42.9792 35.7349Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function EventDrawCard() {
  const t = useTranslations('event.draw');

  return (
    <div className="flex flex-col items-center gap-4 rounded-[16px] bg-v2-surface-secondary p-6 shadow-v2-card">
      <DrawIcon className="text-v2-text-secondary" />
      <span className="text-center text-[24px] font-medium leading-8 text-v2-text-primary">
        {t('resultDraw')}
      </span>
    </div>
  );
}
